var map = {
	"./affordable_clean.png": 82906,
	"./banner-1.png": 69134,
	"./banner-2.png": 96965,
	"./banner-3.png": 44700,
	"./below_water.png": 38911,
	"./benz-watermark.png": 93068,
	"./cancel_icon.svg": 21912,
	"./clean_water.png": 39343,
	"./climate_action.png": 74528,
	"./decent_work.png": 35397,
	"./deleteIcon.svg": 48376,
	"./editIcon.svg": 52009,
	"./email-icon-white.svg": 94164,
	"./email-icon.svg": 33908,
	"./events-new.png": 60184,
	"./exportIcon.svg": 2107,
	"./failed_icon.png": 42937,
	"./failed_icon.svg": 21471,
	"./file_icon.svg": 65260,
	"./filter_icon.svg": 13268,
	"./first_page.svg": 94562,
	"./gender_equality.png": 87310,
	"./good_health.png": 17868,
	"./hours-new.png": 92668,
	"./hubspot.png": 99137,
	"./impact-bg.png": 70234,
	"./importIcon.svg": 54634,
	"./import_icon.svg": 40827,
	"./industry_innovation.png": 69004,
	"./life_land.png": 68998,
	"./line_icon.png": 91794,
	"./logo-benz.png": 8297,
	"./logo-mbrdi.svg": 88184,
	"./long-arrow-left.png": 90072,
	"./long-arrow-right.png": 52333,
	"./mail-new.png": 19510,
	"./map.svg": 74252,
	"./microsoft-teams-white.svg": 48799,
	"./microsoft-teams.svg": 35119,
	"./next-arrow.png": 65869,
	"./no_poverty.png": 75381,
	"./partnership_goals.png": 98037,
	"./peace_justice.png": 5132,
	"./previous-arrow.png": 32529,
	"./profiles-banner.png": 26885,
	"./quality_education.png": 25408,
	"./quote.png": 97072,
	"./reduced_inequalities.png": 9218,
	"./responsible_consumption.png": 14620,
	"./retry_icon.svg": 78840,
	"./search.png": 32670,
	"./selectIcon.svg": 91365,
	"./success-icon-outlined.svg": 99782,
	"./success_icon.png": 65177,
	"./sustainable_city.png": 87561,
	"./volunteers-new.png": 25274,
	"./zero_hunger.png": 90768
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96028;